// ** MUI Imports
import MuiChip from '@mui/material/Chip';
import { SxProps, Theme } from '@mui/material/styles';

// ** Types
import { CustomChipProps } from './types';

// ** Hooks Imports
import useBgColor, { UseBgColorType } from 'src/@core/hooks/useBgColor';

const Chip = (props: CustomChipProps) => {
  // ** Props
  const { sx, skin, color } = props;

  // ** Hook
  const bgColors = useBgColor();

  const colors: UseBgColorType = {
    primary: { ...bgColors.primaryLight },
    secondary: { ...bgColors.secondaryLight },
    success: { ...bgColors.successLight },
    error: { ...bgColors.errorLight },
    warning: { ...bgColors.warningLight },
    info: { ...bgColors.infoLight }
  };

  const lightSkinColorSx: SxProps<Theme> | undefined = color ? colors[color] : undefined;
  const mergedSx: SxProps<Theme> | undefined =
    skin === 'light' && lightSkinColorSx ? (sx ? ([lightSkinColorSx, sx] as SxProps<Theme>) : lightSkinColorSx) : sx;

  return <MuiChip {...props} variant="filled" sx={mergedSx} />;
};

export default Chip;
